define('shared/initializer/form/adapters/mixins/fields/Password',[
    'shared/lib/RSVP',
    '../../../constants'
], 
function(
    RSVP,
    constants
) {
    'use strict';

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var fieldPassowrd = me.items[constants.FIELD.PASSWORD];
        var fieldShowPassowrd = me.items[constants.FIELD.SHOW_PASSWORD];

        if (fieldShowPassowrd == null || fieldPassowrd == null) {
            return RSVP.resolve();
        }

        var $el = fieldShowPassowrd.$el;
        var $passwordInput = fieldPassowrd.$el;

        function togglePassword() {
            var isChecked = $el.prop('checked');

            try{
                if (isChecked) {
                    $passwordInput.attr('type','text');
                }
                else {
                    $passwordInput.attr('type','password');
                }
            }
            catch(ex){
                // that means it must be IE < 9 
                $el.closest('.form-group').hide();
            }
            
        }

        $el.on('change', togglePassword);
        togglePassword();

        return RSVP.resolve();
    };

    return Ctor;
});
